import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

export const BACKGROUND_LOCATION_KEY = "backgroundLocation";

export const PRODUCT_LAYERS_KEY = "productLayers";

export const PRODUCT_PATH_PREFIX = "/product/";

export const LAYER_ID_KEY = "productLayerId";

export const OVERLAY_EXIT_MS = 250;

export const MAX_LIVE_LAYERS = 3;

export const ProductPageOverlayContext = createContext(null);

export const useProductPageOverlay = () => useContext(ProductPageOverlayContext);

export const isProductPath = (pathname) => String(pathname ?? "").toLowerCase().startsWith(PRODUCT_PATH_PREFIX);

const layerKey = (location) => location.state?.[LAYER_ID_KEY] ?? location.key;

const toLayer = (location) => {
  const { [BACKGROUND_LOCATION_KEY]: background, [PRODUCT_LAYERS_KEY]: below, ...state } = location.state ?? {};
  return {
    pathname: location.pathname,
    search: location.search ?? "",
    hash: location.hash ?? "",
    state: Object.keys(state).length ? state : null,
    key: layerKey(location),
  };
};

export const readProductStack = (location) => {
  const state = location.state ?? {};
  if (!isProductPath(location.pathname) || !state[BACKGROUND_LOCATION_KEY]) return { background: location, layers: [] };
  const below = Array.isArray(state[PRODUCT_LAYERS_KEY]) ? state[PRODUCT_LAYERS_KEY] : [];
  return {
    background: state[BACKGROUND_LOCATION_KEY],
    layers: [...below, { ...location, key: layerKey(location) }],
  };
};

export const productLinkState = (current) => {
  const { background, layers } = readProductStack(current);
  return { [BACKGROUND_LOCATION_KEY]: background, [PRODUCT_LAYERS_KEY]: layers.map(toLayer) };
};

export const sameLayerState = (location, extra) => ({
  ...(location.state ?? {}),
  ...extra,
  [LAYER_ID_KEY]: layerKey(location),
});

export const isLiveLayer = (depth, leaving, layerCount) => !leaving && depth >= layerCount - MAX_LIVE_LAYERS;

export const usePageLocation = () => readProductStack(useLocation()).background;
